export const IDENTIFIANT_SOUSCRIPTION_FORM_NAME = "identifiantSouscription";
export const CODE_PACKAGE_FORM_NAME = "codePackage";
export const VALIDITE_DU_FORM_NAME = "validiteDu";
export const VALIDITE_AU_FORM_NAME = "validiteAu";
export const TRANSACTIONS_RESTANTES_FORM_NAME = "transactionsRestantes";
export const SOLDE_SUPLEMENTAIRE_FORM_NAME = "solde";
export const SOUSCRIPTION_SUSPENDU_FORM_NAME = "souscriptionSuspendu";
export const MOTIF_MODIFICATION_FORM_NAME = "motifModification";
export const STATUS_MODIFICATION_FORM_NAME = "statusSouscription";
